export default function () {
    return {
        customerIsLogin: false,
        init() {
            window.require(
                ['Magento_Customer/js/customer-data'],
                (customerData) => {
                    this.checkCustomerIsLogin(customerData);
                }
            );
        },
        checkCustomerIsLogin(customerData) {
            const customer = customerData.get('customer')();
            customerData.reload(['customer'], false);

            this.customerIsLogin = !!(
                customer &&
                customer.firstname &&
                customer.firstname.length > 0
            );
        }
    };
}
